import React, {Component} from 'react';
import {TopSelect} from "../../componentsTopsa/selects/TopSelects";

export default class InlineSelect extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: null
        };
        this.onChangeValue = this.onChangeValue.bind(this)
        this.onClickSave = this.onClickSave.bind(this)
        this.renderOption = this.renderOption.bind(this)
    }

    componentDidMount() {
        this.setState({value: this.props.options.find(p => p[this.props.itemvalue] === this.props.val)})
    }

    onChangeValue(e) {
        this.setState({value: e})
    }

    onClickSave() {
        let obj = this.props.item;

        if (Boolean(this.state.value)) {
            obj[this.props.itemvalue] = this.state.value[this.props.itemvalue]
        }
        this.props.handleClickZapisz(obj)
    }

    renderOption(option) {
        return (
            <div>
                <span className={'label label-ebus-default'}>{option[this.props.optionRenderer1]}</span>
                <span style={{marginLeft:'7px'}}>{option[this.props.optionRenderer2]}</span>
            </div>
        )
    }

    render() {

        return (
            <div className={'inlineInputComponent'}>
                {/*<input className={'form-control input-sm'} defaultValue={this.props.val} onChange={this.onChangeValue}/>*/}
                <TopSelect onChange={this.onChangeValue}
                           value={this.state.value}
                           options={this.props.options}
                           valueRenderer={this.renderOption}
                           optionRenderer={this.renderOption}
                           valueKey={this.props.valKey}
                           labelKey={this.props.labelKey}
                           clearable={false}
                />
                <button className={'btn btn-primary btn-sm'} title={'Zapisz'} onClick={this.onClickSave}><i className={'fa fa-check'}></i></button>
                <button className={'btn btn-default btn-sm'} title={'Anuluj'} onClick={()=>this.props.handleAnuluj()}><i className={'fa fa-times'}></i></button>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/shared/inlineFormsControl/InlineSelect.js